module.exports = __webpack_public_path__ + "static/media/icon-simple-checker.ca5253c8.svg";